<div class="payment-cvv">
  <div class="row">
    <div class="">
      <img src="{{cvvVisaImgPath}}" id="visaImg" alt=""/>
    </div>
    <div class="text-block" id="visaText">
      <strong>Visa&reg;, Mastercard&reg;, and Discover&reg;:</strong><br />
      Turn your card over and look at the signature box. You should see either the entire 16-digit credit card
      number or<br />just the last four digits followed by a special 3-digit code. This 3-digit code is your
      CVV/CVC number / Card Security Code.
    </div>
  </div>
  <div class="row">
    <div class="">
      <img src="{{cvvAmexImgPath}}" id="amexImg" alt="" />
    </div>
    <div class="text-block" id="amexText">
      <strong>American Express&reg;:</strong><br />
      Look for the 4-digit code printed on the front of your card just above and to the right of your main credit
      card number. This 4-digit code is your Card Identification Number (CID).
    </div>
  </div>
</div>
<div class="buttons-container">
  <button id="closeCvvButton" class="button mat-button" (click)="close()">{{appStrings.button_close}}</button>
</div>
